import React, { useMemo } from "react";
import { StudentCarousel } from "@/components/StudentCarousel";
import { useFetchStudents } from "@/hooks/useFetchStudents";
import { useTranslation } from "react-i18next";
import { FilterContext } from "@/types/FilterContext";
import { StudentOrdering } from "@/types/StudentOrdering";
import { useBuildUrlState } from "@/hooks/useUrlSerializer";
import {
  SortDirectionEnum,
  StudentListFeedPostsSortableFieldEnum,
  YesNoEnum,
} from "@/__generated__/types";
import { FilterState } from "@/components/FilterSidebar/FilterState";

export const RecentlyViewedCarousel = () => {
  const { t } = useTranslation();

  const context = useMemo(() => new FilterContext("feedPosts"), []);
  const ordering = useMemo(
    () =>
      new StudentOrdering(
        StudentListFeedPostsSortableFieldEnum.ViewedAt,
        SortDirectionEnum.Desc,
        "feedPosts",
      ),
    [],
  );

  const { items: students, loading } = useFetchStudents({
    context,
    ordering,
    paginationVariables: {
      first: 10,
    },
    filterState: new FilterState({ hasProfilePhoto: YesNoEnum.Yes }),
  });

  const orderingQuery = useBuildUrlState("STUDENT_ORDERING")(ordering);
  const fc = useBuildUrlState("FILTER_CONTEXT")(context);

  return (
    <>
      <section
        className="max-h-[283px] w-full"
        data-testid="feed-post-carousel"
      >
        <StudentCarousel
          title={t("feedPost.recentlyViewed")}
          students={students}
          isLoading={loading}
          showLocation={true}
          viewAllLink={"students"}
          viewAllQuery={{ ...orderingQuery, ...fc }}
        />
      </section>
    </>
  );
};
